// src/api/accountApi.js

import API_BASE_URL from "./baseUrl";
const BASE = API_BASE_URL;

/**
 * Fetch summary for AuthLanding.
 * Accepts: { id?, phoneNumber?, email? }
 */
export async function fetchUserSummary(identity) {
  const id = identity?.id ?? null;
  const phoneNumber = identity?.phoneNumber ?? null;
  const email = identity?.email ?? null;

  const key = id ? `id:${id}` : phoneNumber ? `ph:${phoneNumber}` : email ? `em:${email}` : null;
  if (!key) return { hasActivity: false, upcoming: [], draftCarts: [], recentSearches: [] };

  const token =
    (typeof localStorage !== "undefined" && localStorage.getItem("token")) || null;

  const url = BASE
    ? `${BASE.replace(/\/$/, "")}/account/summary?key=${encodeURIComponent(key)}`
    : null;

  if (url) {
    try { 
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        credentials: "include",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      return {
        hasActivity: !!data?.hasActivity,
        upcoming: data?.upcoming || [],
        draftCarts: data?.draftCarts || [],
        recentSearches: data?.recentSearches || [],
      };
    } catch {
      // fall back
    }
  }

  // local fallback
  const lsKey = `wr_summary_${key}`;
  try {
    const raw = localStorage.getItem(lsKey);
    if (raw) {
      const data = JSON.parse(raw);
      return {
        hasActivity: !!data?.hasActivity,
        upcoming: data?.upcoming || [],
        draftCarts: data?.draftCarts || [],
        recentSearches: data?.recentSearches || [],
      };
    }
  } catch {}

  return { hasActivity: false, upcoming: [], draftCarts: [], recentSearches: [] };
}

export function seedUserSummary(identityKey) {
  if (!identityKey) return;
  const mock = {
    hasActivity: true,
    upcoming: [{ id: "bk_123", date: "2025-11-04", city: "Pune", cars: 3, status: "Confirmed" }],
    draftCarts: [{ id: "dr_1", pickupLocation: "Kalyani Nagar", finalDestination: "Baner" }],
    recentSearches: [{ id: "rs_1", pickupLocation: "Viman Nagar", category: ["normal"] }],
  };
  localStorage.setItem(`wr_summary_${identityKey}`, JSON.stringify(mock));
}
